import BaseType from "../BaseType";
import Site from "./Site";

export default class SiteResponseItem extends BaseType {
  SiteResponseHeaderId: string = "";
  SiteId: string = "";
  Site: Site | undefined;
}
